import { NotificationButton } from '@avanta/shared/components/chat/NotificationButton';
import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { MessageCircleMore } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ChatStartConfirmDialog } from 'components/ChatStartConfirmDialog';
import { PSYCHOLOGIST_ID } from 'constants/chat';
import { ROUTES } from 'constants/routes';
import { useComponentTracking } from 'tracking/hooks/useTrackingComponent';

export const ChatBanner = (): React.ReactElement => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.HOME);
  const { trackEmotionalSupportChatStart } = useComponentTracking();
  const { showDialog } = useDialogContext();

  const handleOpenEmotionalChat = async (): Promise<void> => {
    await trackEmotionalSupportChatStart({ supporterId: PSYCHOLOGIST_ID });
    showDialog({
      component: (
        <ChatStartConfirmDialog
          onConfirm={async () => {
            await trackEmotionalSupportChatStart({ supporterId: PSYCHOLOGIST_ID });
            navigate(ROUTES.CHAT, { state: { psychologist: true } });
          }}
        />
      ),
    });
  };

  return (
    <Card className="w-full p-0 px-4 py-6 text-left am-3xl:px-10 am-3xl:py-8">
      <div className="flex w-full flex-col items-center gap-4 am-3xl:flex-row am-3xl:items-center am-3xl:gap-10">
        <MessageCircleMore
          aria-hidden
          className="size-12 shrink-0 text-teal-600 am-3xl:size-18"
          strokeWidth={1.5}
        />
        <div className="flex w-full min-w-0 flex-col gap-6 am-3xl:flex-1">
          <div className="flex w-full flex-col gap-2">
            <h3 className="font-medium leading-5 text-denim-500 am-3xl:text-xl am-3xl:leading-6 am-3xl:text-denim-800">
              {t('Pae.ChatBanner.heading')}
            </h3>
            <p className="text-base leading-5 text-denim-500">{t('Pae.ChatBanner.body')}</p>
          </div>
          <NotificationButton
            variant="secondary"
            size="lg"
            className="w-full am-3xl:w-fit"
            onClick={handleOpenEmotionalChat}
            notificationUserId={PSYCHOLOGIST_ID}
          >
            {t('Pae.ChatBanner.cta')}
          </NotificationButton>
        </div>
      </div>
    </Card>
  );
};
